module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("\n    Bulk Update Jobs\n  ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Bulk Update Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("Please paste data to be imported below, column order must match the export from the jobs page.")]), _vm._v(" "), _c('v-container', [_c('v-textarea', {
    attrs: {
      "label": "Excel Data Input"
    },
    model: {
      value: (_vm.excelInput),
      callback: function($$v) {
        _vm.excelInput = $$v
      },
      expression: "excelInput"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Columns to import",
      "items": _vm.availableColumns,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "return-object": ""
    },
    model: {
      value: (_vm.selectedColumns),
      callback: function($$v) {
        _vm.selectedColumns = $$v
      },
      expression: "selectedColumns"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Input includes header row"
    },
    model: {
      value: (_vm.includeHeaders),
      callback: function($$v) {
        _vm.includeHeaders = $$v
      },
      expression: "includeHeaders"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.excelInput,
      "loading": _vm.processing
    },
    on: {
      "click": _vm.processRawData
    }
  }, [_vm._v("Process Data")])], 1), _vm._v(" "), (_vm.dataProcessed) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Output Data")]), _vm._v(" "), _c('p', [_vm._v("Green cells will be updated")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-actions": "",
      "items": _vm.processedData,
      "headers": _vm.availableColumns
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', _vm._l((_vm.availableColumns), function(column) {
          return _c('td', {
            class: {
              'green': _vm.selectedColumns.findIndex(function (a) { return column.value === a.value; }) !== -1
            }
          }, [_vm._v(_vm._s(props.item[column.value]))])
        }), 0)]
      }
    }], null, false, 469153014)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    staticClass: "shrink",
    attrs: {
      "label": "I confirm the above output is correct"
    },
    model: {
      value: (_vm.dataLooksGood),
      callback: function($$v) {
        _vm.dataLooksGood = $$v
      },
      expression: "dataLooksGood"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.updating,
      "disabled": !_vm.dataLooksGood
    },
    on: {
      "click": _vm.updateJobs
    }
  }, [_vm._v("Update Job Details")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1f40b54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/BulkUpdateJobsDialog.vue
// module id = 767
// module chunks = 1